import React, { Component } from 'react';
import { X, Shield, BookOpen, BarChart3, Share2 } from 'lucide-react';
interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function WelcomeModal({
  isOpen,
  onClose
}: WelcomeModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-183">
      <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full" data-id="element-184">
        <div className="p-6" data-id="element-185">
          <div className="flex items-center justify-between mb-4" data-id="element-186">
            <h2 className="text-2xl font-bold text-[#164149]" data-id="element-187">
              Welcome to Elze!
            </h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-188">
              <X size={24} data-id="element-189" />
            </button>
          </div>
          <div className="text-center mb-6" data-id="element-190">
            <div className="w-20 h-20 rounded-full bg-[#376770] flex items-center justify-center mx-auto mb-4" data-id="element-191">
              <BookOpen size={36} className="text-white" data-id="element-192" />
            </div>
            <h3 className="text-xl font-semibold text-[#164149]" data-id="element-193">
              Your literary adventure starts here
            </h3>
            <p className="text-gray-600 mt-2" data-id="element-194">
              Thank you for joining us. Discover all the benefits Elze has to
              offer.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-8" data-id="element-195">
            <FeatureCard icon={<Shield size={24} data-id="element-197" />} title="Rights protection" description="Manage and protect your copyrights in a secure and transparent way" data-id="element-196" />
            <FeatureCard icon={<BookOpen size={24} data-id="element-199" />} title="Work publication" description="Publish and share your works with a global audience" data-id="element-198" />
            <FeatureCard icon={<BarChart3 size={24} data-id="element-201" />} title="Royalty monitoring" description="Track your royalties and earnings in real time" data-id="element-200" />
            <FeatureCard icon={<Share2 size={24} data-id="element-203" />} title="Author community" description="Connect with other authors and publishers for collaborations and opportunities" data-id="element-202" />
          </div>
          <div className="flex justify-center" data-id="element-204">
            <button onClick={onClose} className="px-6 py-3 bg-[#376770] text-white rounded-md hover:bg-[#2d5459] transition-colors" data-id="element-205">
              Start exploring
            </button>
          </div>
        </div>
      </div>
    </div>;
}
// Feature Card Component
function FeatureCard({
  icon,
  title,
  description
}) {
  return <div className="bg-[#EFF2F1] p-4 rounded-lg" data-id="element-206">
      <div className="flex items-start" data-id="element-207">
        <div className="p-2 bg-[#C6D6AB]/50 rounded-full text-[#376770]" data-id="element-208">
          {icon}
        </div>
        <div className="ml-3" data-id="element-209">
          <h4 className="text-[#164149] font-medium" data-id="element-210">{title}</h4>
          <p className="text-gray-600 text-sm mt-1" data-id="element-211">{description}</p>
        </div>
      </div>
    </div>;
}